import { render, staticRenderFns } from "./CreateRomaneioView.vue?vue&type=template&id=64278ecb"
import script from "./CreateRomaneioView.vue?vue&type=script&lang=js"
export * from "./CreateRomaneioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports